import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./UserSearch.css";
import Search from "../../images/adminSearch.svg";
import vk from "../../images/vk.svg";
import ozon from "../../images/ozon.svg";
import wb from "../../images/wb.svg";
import SearchImage from "../../images/searchImg.svg";
import ErrorInfo from "../../images/errorInfo.svg";
import Popup from "../Popup/Popup";

function UserSearch() {
  const navigate = useNavigate();
  const [errorInput, setErrorInput] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [formValues, setFormValues] = useState({
    SearchInput: "",
  });

  function handleChange(e) {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  }

  function handleSubmit(event) {
    event.preventDefault();

    // Получаем данные из localStorage и преобразуем их обратно в массив
    const cards = JSON.parse(localStorage.getItem("cards"));

    // Проверяем, что cards является массивом
    if (!Array.isArray(cards)) {
      console.error("Данные в localStorage не являются массивом");
      return;
    }

    const foundCard = cards.find(
      (i) => i.article.toUpperCase() === formValues.SearchInput.toUpperCase()
    );

    if (!foundCard) {
      // Если элемент не найден, присваиваем errorInput значение true
      setErrorInput(true);
      console.log("Элемент не найден, errorInput =", errorInput);
    } else {
      setErrorInput(false);
      localStorage.setItem("active", JSON.stringify(foundCard));
      console.log("Элемент найден и сохранен в localStorage:", foundCard);
      navigate("/active");
    }

    // Возвращаем или используем errorInput (например, для обновления состояния в React)
    return errorInput;
  }
  return (
    <div className="UserSearch">
      <div
        className="social-icons"
        style={{ overflow: hovered ? "visible" : "hidden" }}
      >
        <a
          href="https://vk.com/vandalvision"
          target="_blank"
          rel="noopener noreferrer" // Исправлено
          className="icon"
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          <img src={vk} alt="VK" />
          <span className="tooltip">vandalvision</span>
        </a>
        <a
          href="https://www.wildberries.ru/seller/1282869"
          target="_blank"
          rel="noopener noreferrer" // Исправлено
          className="icon"
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          <img src={wb} alt="WB" />
          <span className="tooltip">YOUN</span>
        </a>
        <a
          href="https://www.wildberries.ru/seller/271668"
          target="_blank"
          rel="noopener noreferrer" // Исправлено
          className="icon"
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          <img src={wb} alt="WB" />
          <span className="tooltip">yakuza</span>
        </a>
        <a
          href="https://www.wildberries.ru/seller/4152718"
          target="_blank"
          rel="noopener noreferrer" // Исправлено
          className="icon"
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          <img src={wb} alt="WB" />
          <span className="tooltip">Tatar</span>
        </a>
        <a
          href="https://www.ozon.ru/seller/tatar-2131904/products/?miniapp=seller_2131904"
          target="_blank"
          rel="noopener noreferrer" // Исправлено
          className="icon"
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          <img src={ozon} alt="Ozon" />
          <span className="tooltip">Tatar</span>
        </a>
        <a
          href="https://www.ozon.ru/seller/kartiny-na-stenu-1532754/products/?miniapp=seller_1532754"
          target="_blank"
          rel="noopener noreferrer" // Исправлено
          className="icon"
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          <img src={ozon} alt="Ozon" />
          <span className="tooltip">картины на стену</span>
        </a>
      </div>
      <div className="UserSearch__popup">
        <p className="UserSearch__popup__title">Найди инструкцию здесь</p>
        <p className="UserSearch__popup__subtitle">без лишних проблем</p>

        <form onSubmit={handleSubmit} className="UserSearch__popup__form">
          <input
            className="UserSearch__popup__form__input"
            type="text"
            placeholder="Введите артикул"
            value={formValues.SearchInput}
            onChange={handleChange}
            name="SearchInput"
          />
          <button type="submit" className="UserSearch__popup__form__btn">
            <img src={Search} alt="search" />
          </button>
          {errorInput && (
            <p className="UserSearch__popup__form__err">
              Не правельный артикул
            </p>
          )}
        </form>
        <div className="UserSearch__popup__infocont">
          <p className="UserSearch__popup__infocont__text">
            <img alt="img" src={SearchImage} />
            Ищите артикул на обратной или лицевой стороне
          </p>
          <button
            type="button"
            onClick={() => {
              setPopupOpen(true);
            }}
            className="UserSearch__popup__infocont__btn"
          >
            <img alt="img" src={ErrorInfo} />
            Не могу найти
          </button>
        </div>
        {popupOpen && <Popup setPopupOpen={setPopupOpen} />}
      </div>
    </div>
  );
}

export default UserSearch;
